import { listingsActions } from '~/legacy/store/pages/listings';

export const setListingLoading = (loading) =>
  listingsActions.setLoading(loading);
